module.exports = __webpack_public_path__ + "static/media/desktop.690da18.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Smena7/desktop.mp4
// module id = SLT/
// module chunks = 1